import type { Currency } from '@shared/utils';
import { notFound } from 'next/navigation';
import type { ProductVertical } from '../../PageToolbarWithNavigation';
import { fetchGameInfo } from './fetchGameInfo';
import { GameInfoPageContent } from './GameInfoPageContent';

type GameInfoPageConfig = {
  productVertical: ProductVertical;
  currency: Currency;
  translationNamespace?: string;
};

type Props = {
  params: Promise<{ gameName: string }>;
  searchParams: Promise<{ position?: string; variant?: 'grid' | 'list' }>;
};

function createGameInfoPage(config: GameInfoPageConfig) {
  const { productVertical, currency } = config;

  async function GameInfoPage({ params }: Props) {
    const gameName = (await params).gameName;
    const game = await fetchGameInfo(gameName, currency);

    if (!game) {
      return notFound();
    }

    return <GameInfoPageContent game={game} gameName={gameName} productVertical={productVertical} currency={currency} />;
  }

  return GameInfoPage;
}

export { createGameInfoPage };
